document.addEventListener('DOMContentLoaded', function() {
  class MegaMenuCarousel {
    constructor(container) {
      this.container = container;
      this.slidesContainer = container.querySelector('.carousel-slides-container');
      this.products = Array.from(container.querySelectorAll('.carousel-product'));
      this.prevBtn = container.querySelector('.carousel-nav.prev');
      this.nextBtn = container.querySelector('.carousel-nav.next');
      this.pagination = container.querySelector('.carousel-pagination');
      this.currentSlide = 0;
      this.productsPerRow = 5;
      
      this.init();
    }
    
    init() {
      if (!this.slidesContainer || this.products.length === 0) return;
      
      this.totalProducts = this.products.length;
      
      // Calculate total slides needed (each slide has up to 10 products - 2 rows of 5)
      this.totalSlides = Math.ceil(this.totalProducts / 10);
      
      // Hide navigation if only one slide
      if (this.totalSlides <= 1) {
        this.hideNavigation();
      } else {
        this.showNavigation();
      }
      
      this.createSlides();
      this.createPagination();
      this.setupEventListeners();
      this.updateCarousel();
    }
    
    createSlides() {
      // Clear existing content
      this.slidesContainer.innerHTML = '';
      
      for (let slideIndex = 0; slideIndex < this.totalSlides; slideIndex++) {
        const slide = document.createElement('div');
        slide.className = 'carousel-slide';
        
        // Create rows for this slide
        const row1 = document.createElement('div');
        row1.className = 'carousel-slide-row';
        
        const row2 = document.createElement('div');
        row2.className = 'carousel-slide-row';
        
        // Calculate products for this slide
        const startIndex = slideIndex * 10;
        const endIndex = Math.min(startIndex + 10, this.totalProducts);
        
        // Add products to rows
        for (let i = startIndex; i < endIndex; i++) {
          const product = this.products[i].cloneNode(true);
          
          // First 5 products go to row1, next 5 to row2
          if (i < startIndex + 5) {
            row1.appendChild(product);
          } else {
            row2.appendChild(product);
          }
        }
        
        // Add rows to slide
        if (row1.children.length > 0) {
          slide.appendChild(row1);
        }
        if (row2.children.length > 0) {
          slide.appendChild(row2);
        }
        
        this.slidesContainer.appendChild(slide);
      }
    }
    
    createPagination() {
      if (!this.pagination) return;
      
      this.pagination.innerHTML = '';
      
      // Only show pagination if multiple slides
      if (this.totalSlides > 1) {
        for (let i = 0; i < this.totalSlides; i++) {
          const dot = document.createElement('button');
          dot.className = 'carousel-dot';
          dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
          if (i === 0) dot.classList.add('active');
          dot.addEventListener('click', () => this.goToSlide(i));
          this.pagination.appendChild(dot);
        }
      }
    }
    
    hideNavigation() {
      if (this.prevBtn) this.prevBtn.style.display = 'none';
      if (this.nextBtn) this.nextBtn.style.display = 'none';
      if (this.pagination) this.pagination.style.display = 'none';
    }
    
    showNavigation() {
      if (this.prevBtn) this.prevBtn.style.display = 'flex';
      if (this.nextBtn) this.nextBtn.style.display = 'flex';
      if (this.pagination) this.pagination.style.display = 'flex';
    }
    
    setupEventListeners() {
      // Navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prevSlide());
      }
      
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.nextSlide());
      }
      
      // Touch support (only for multiple slides)
      if (this.totalSlides > 1) {
        this.slidesContainer.addEventListener('touchstart', (e) => {
          this.touchStartX = e.changedTouches[0].screenX;
        }, {passive: true});
        
        this.slidesContainer.addEventListener('touchend', (e) => {
          this.touchEndX = e.changedTouches[0].screenX;
          this.handleSwipe();
        }, {passive: true});
      }
    }
    
    handleSwipe() {
      const difference = this.touchStartX - this.touchEndX;
      if (difference > 50) this.nextSlide();
      if (difference < -50) this.prevSlide();
    }
    
    prevSlide() {
      this.goToSlide(this.currentSlide - 1);
    }
    
    nextSlide() {
      this.goToSlide(this.currentSlide + 1);
    }
    
    goToSlide(slideIndex) {
      if (this.totalSlides <= 1) return;
      
      if (slideIndex < 0) slideIndex = 0;
      if (slideIndex >= this.totalSlides) slideIndex = this.totalSlides - 1;
      
      this.currentSlide = slideIndex;
      this.updateCarousel();
    }
    
    updateCarousel() {
      // Update pagination
      const dots = this.pagination?.querySelectorAll('.carousel-dot');
      dots?.forEach((dot, index) => {
        const isActive = index === this.currentSlide;
        dot.classList.toggle('active', isActive);
        dot.style.width = isActive ? '40px' : '15px';
      });
      
      // Update button states
      if (this.prevBtn) {
        this.prevBtn.disabled = this.currentSlide === 0;
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = this.currentSlide === this.totalSlides - 1;
      }
      
      // Slide transition
      if (this.totalSlides > 1) {
        const offset = -this.currentSlide * 100;
        this.slidesContainer.style.transform = `translateX(${offset}%)`;
      }
    }
  }

  // Initialize each carousel separately to prevent conflicts
  document.querySelectorAll('.mega-menu-carousel-container').forEach(container => {
    new MegaMenuCarousel(container);
  });
});